import { PrizeCard } from "@/components/giveaway/PrizeCard";
import { TicketsCard } from "@/components/giveaway/TicketsCard";
import { asset } from "@/lib/assets";

export function Giveaway() {
  return (
    <section
      id="tickets"
      style={{ backgroundImage: `url('${asset("images/webp/giveaway-bg.webp")}')` }}
      className="scroll-mt-20 bg-white bg-cover py-16 sm:py-20 lg:scroll-mt-28 lg:py-24"
    >
      {/* Equal-height cards on one symmetric grid — no per-column padding. */}
      <div className="container mx-auto px-5">
        <div className="grid items-stretch gap-8 md:grid-cols-2 lg:gap-12">
          {/* The card is taken out of flow so the player list can't inflate the
              row — the height comes from the prize card beside it, and the
              min-height only applies when the grid is a single column. */}
          <div className="relative order-2 min-h-150 md:order-1">
            <div className="absolute inset-0">
              <TicketsCard />
            </div>
          </div>

          <div className="order-1 md:order-2">
            <PrizeCard />
          </div>
        </div>
      </div>
    </section>
  );
}
